import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import {TimeoutWrapperService} from '../timeout.wrapper/timeout.wrapper.service';
import { ApiService } from '../api/api.service';
import { TimestampRange } from '../../components/time-picker/types';

@Injectable({
  providedIn: 'root'
})
export class DeltaService {

  private readonly deltaTimeInterval: number = 60000; //1 min
  private readonly timeDifference: number = 0;
  deltaTime: BehaviorSubject<any>;
  private timeoutPromise: any;

  constructor(private readonly apiService: ApiService, private readonly timeout: TimeoutWrapperService) {
   this.deltaTime = new BehaviorSubject({});
     this.timeoutPromise = null;
  }

 run(renew = false): void {
    // When DELTA querying was stopped, need to
    // restart initial querying time
      this.deltaTime.next(this._startTimeRange());
      // Two minutes interval based on toTime
    // note: this overwrites a reference to Promise from previous run
    // it is a job of TimeoutWrapper to destroy reference to fulfilled promises.
      this.timeoutPromise = this.timeout.add(() => {
        this.run();
    }, this.deltaTimeInterval);
  }

  stop(): void {
    if (this.timeoutPromise) {
      this.timeout.cancel(this.timeoutPromise);
      this.deltaTime.next({});
    }
  }

  private _startTimeRange(): TimestampRange {
    // For RTI/analytics efficiency
    // if we make all queries toTime and fromTime be on whole number second
    // boundary, then when multiple users of the same tenant log in, they
    // will share dimension/OID caching from RTI thus reducing backen load.
    const coeff = 1000 * 60;
    // delay 'now' by 31 sec - giving backend services to collect information from agents and put it into databases
    const initTime =
      Math.floor(
        (Date.now() - 60 * 1000 - 31 * 1000 - this.timeDifference) / coeff
      ) * coeff;

    return {
      fromTime: initTime,
      toTime: initTime
    };
  }
}
